export default {
  name: 'AudioPlayer',
  displayName: {
    en: 'Audio Player',
    ja: '音楽再生',
  },
  defaultWidth: 350,
  defaultHeight: 140,
  resizeX: true,
  props: [
    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      type: 'text',
      default: 'Audio Player',
    },
    {
      name: 'url',
      displayName: {
        en: 'URL',
        ja: 'URL',
      },
      type: 'text',
      default: '',
    },
    {
      name: 'autoPlay',
      displayName: {
        en: 'Auto Play',
        ja: '自動再生',
      },
      type: 'boolean',
      default: false,
    },
    {
      name: 'onAudioPlayed',
      type: 'action',
      displayName: {
        en: 'On Audio Played',
        ja: '音楽再生が開始した時の',
      },
    },
    {
      name: 'onAudioFinished',
      type: 'action',
      displayName: {
        en: 'On Audio Finished',
        ja: '音楽再生が終了した時の',
      },
    },
  ],
};
